export default "__VITE_ASSET__HPMWJoNB__"